<template>
  <div class="__scale_summerwinter">
    <div class="columns">
      <div class="column is-one-thirds">
        <div v-show="which==0" class="details">
          <h2 class="title is-5">Characteristics of <span class="summer">spring/summer</span> growth</h2>
          <ul>
            <li>Wide circuli relative to narrower circuli spacing in fall and winter.</li>
            <li>Larger, thicker circuli. Clear separation among circuli, unlike winter, which can look compressed.</li>
            <li>Circuli more complete. Can usually be followed all the way around scale from one side of base to the other.</li>
            <li>Ends of circuli ("tails") tend to go straight into base.</li>
            <li>Less reticulation where circuli meet posterior.</li>
          </ul>
        </div>
        <div v-show="which==1" class="details">
          <h2 class="title is-5">Characteristics of <span class="winter">fall/winter</span> growth</h2>
          <ul>
            <li>Narrow circuli spacing relative to wide circuli spacing in spring and summer.</li>
            <li>Thin circuli relative to larger, thicker circuli formed in summer.</li>
            <li>Discontinuous, broken circuli.</li>
            <li>Circuli are incomplete from one side to the other.</li>
            <li>Circuli braid and branch.</li>
            <li>Tails "turn in" at base of scale.</li>
            <li>Annual zone extends into posterior. Look for a visible shadow, increased reticulation, and extension of circuli into posterior of scale.</li>
          </ul>
        </div>
      </div>
      <div class="column is-two-thirds">
        <div class="field">
          <span>Summer</span>
          <b-switch
            class="switch"
            v-model="which"
            size="is-medium"
            passive-type="is-warning"
            type="is-info"
          ></b-switch>
          <span>Winter</span>
        </div>
        <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 800 984"
          style="enable-background:new 0 0 800 984;"
          xml:space="preserve"
        >
          <g id="Layer_1">
            <image
              style="overflow:visible;"
              width="800"
              height="984"
              xlink:href="/img/16-NK8103M003.jpg"
            />
          </g>
          <g id="Summer" v-show="which==0">
            <path
              class="st0"
              d="M145.9,463.5H31.1c-4.1,0-7.5-3.4-7.5-7.5v-14.5c0-4.1,3.4-7.5,7.5-7.5h114.7c4.1,0,7.5,3.4,7.5,7.5V456
		C153.3,460.2,150,463.5,145.9,463.5z"
            />
            <path
              id="path898_2_"
              class="st1"
              d="M226.2,443.7l82.2-2.7l-4.3-10.6l25.2,14.7l-23.1,17l2.7-12.5L226.2,443.7z"
            />
            <path
              id="path898-0_2_"
              class="st1"
              d="M163.8,357.2l82.2-2.7l-4.3-10.6l25.2,14.7l-23.1,17l2.7-12.5L163.8,357.2z"
            />
            <path
              id="path898-1_2_"
              class="st1"
              d="M113,258.7l82.2-2.7l-4.3-10.6l25.2,14.7l-23.1,17l2.7-12.5L113,258.7z"
            />
            <text transform="matrix(1 0 0 1 29.6579 455.4725)" class="st2 st3 st4">Thick circuli</text>
          </g>
          <g id="Winter" v-show="which==1">
            <path
              id="path866_1_"
              class="st5"
              d="M531.2,328.7l24.2-15.9l-4.6,11l88.5,3.9l-87.8,5.8l2.4,11L531.2,328.7z"
            />
            <path
              id="path866-7_1_"
              class="st5"
              d="M535.9,203.8l24.2-15.9l-4.6,11l88.5,3.9l-87.8,5.8l2.4,11L535.9,203.8z"
            />
            <path
              id="path866-7-6_1_"
              class="st5"
              d="M514.3,462.7l24.2-15.9l-4.6,11l88.5,3.9l-87.8,5.8l2.4,11L514.3,462.7z"
            />
            <g>
              <path
                class="st6"
                d="M776.5,305.7H638.8c-4.1,0-7.5-3.4-7.5-7.5v-67.1c0-4.1,3.4-7.5,7.5-7.5h137.6c4.1,0,7.5,3.4,7.5,7.5v67.1
			C784,302.3,780.6,305.7,776.5,305.7z"
              />
              <text transform="matrix(1 0 0 1 639.3065 248.0428)" class="st7 st3 st4">Discontinuous</text>
              <text transform="matrix(1 0 0 1 639.3065 272.0428)" class="st7 st3 st4">and broken</text>
              <text transform="matrix(1 0 0 1 639.3065 296.0428)" class="st7 st3 st4">circuli</text>
            </g>
            <g>
              <path
                class="st6"
                d="M756.3,472.9H641.6c-4.1,0-7.5-3.4-7.5-7.5v-14.5c0-4.1,3.4-7.5,7.5-7.5h114.7c4.1,0,7.5,3.4,7.5,7.5v14.5
			C763.8,469.6,760.4,472.9,756.3,472.9z"
              />
              <text transform="matrix(1 0 0 1 642.8619 465.0324)" class="st7 st3 st4">Thin circuli</text>
            </g>
            <path
              id="path866-7-6_2_"
              class="st5"
              d="M631.3,912.1l-25.8,13.1l5.8-10.4L523.8,901l87.9,4l-1.2-11.2L631.3,912.1z"
            />
            <g>
              <path
                class="st6"
                d="M512.9,910.8h-87.3c-3.1,0-5.7-3.4-5.7-7.5v-14.5c0-4.1,2.6-7.5,5.7-7.5h87.3c3.1,0,5.7,3.4,5.7,7.5v14.5
			C518.6,907.5,516,910.8,512.9,910.8z"
              />
              <text transform="matrix(1 0 0 1 431.0713 902.9843)" class="st7 st3 st4">Shadow</text>
            </g>
          </g>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import { BSwitch } from "buefy/src/components/switch";

export default {
  name: "ScaleAnnuli",
  data() {
    return {
      which: 0
    };
  },
  components: {
    BSwitch
  }
};
</script>

<style lang="scss" scoped>
@import "../theme.scss";

.__scale_summerwinter {
  width: 100%;
  // margin: 0 auto;
  background: white;
  border-radius: 30px;
  box-shadow: 3px 3px 6px #00000030;
  overflow: hidden;
  position: relative;

  .field {
    position: absolute;
    top: 10px;
    left: 35%;
    font-weight: 700;
    font-family: "Open Sans", sans-serif;
    background-color: white;
    padding: 30px;
    border-radius: 30px;

    .switch {
      padding-left: 10px;
    }

    span {
      font-size: 20px;
    }
  }

  svg {
    margin: -10px;
    border-radius: 30px;
  }

  .st0 {
    fill: #f6eb16;
  }
  .st1 {
    fill: #f6eb16;
    stroke: #000000;
    stroke-miterlimit: 11.3386;
  }
  .st2 {
    fill: #414042;
  }
  .st3 {
    font-family: "Open Sans", sans-serif;
    font-weight: 700;
  }
  .st4 {
    font-size: 20px;
  }
  .st5 {
    fill: #00aeef;
    stroke: #000000;
    stroke-miterlimit: 11.3386;
  }
  .st6 {
    fill: #00aeef;
  }
  .st7 {
    fill: #ffffff;
  }

  .details {
    padding: 15px;
  }

  .summer {
    color: $primary;
    font-weight: 700;
  }

  .winter {
    color: #00aeef;
    font-weight: 700;
  }
}
</style>